<template>
  <div>
    <v-row align="center">
      <v-col cols="3">
        <v-select
          class="vue-dropdown"
          v-model="selected"
          :items="options"
          @change="onChange($event)"
          :label="labelName"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["options", "disabled", "selected","labelName"],
  data() {
    return {
      selected: null
    };
  },
  methods: {
    onChange(event) {
      this.$emit("dropdownChange", event);
    }
  }
};
</script>
<style >
.vue-dropdown {
  font-family: "Source Sans Pro", sans-serif;
  left: 0% !important;
}
.vue-dropdown > div > div > .v-menu > .v-menu__content {
  font-family: "Source Sans Pro", sans-serif;
  left: 0% !important;
  top: 38px !important;
  position: absolute !important;
}
</style>